const RATIO_MIN_FALLBACK = 0.1;
const RATIO_MAX_FALLBACK = 0.9;

/**
 * Converte larguras mínimas em px (dos dois painéis) em limites de proporção
 * (0-1), dada a largura real do container. Se os mínimos não couberem na
 * largura disponível, colapsa os dois limites no ponto médio em vez de
 * deixar min > max (que travaria o clamp num extremo e geraria
 * aria-valuemin > aria-valuemax).
 */
export function calcularLimitesRatio(largura, minLeftPx, minRightPx) {
  if (!largura) return { min: RATIO_MIN_FALLBACK, max: RATIO_MAX_FALLBACK };
  const min = Math.min(RATIO_MAX_FALLBACK, minLeftPx / largura);
  const max = Math.max(RATIO_MIN_FALLBACK, 1 - (minRightPx / largura));
  if (min > max) {
    const meio = (min + max) / 2;
    return { min: meio, max: meio };
  }
  return { min, max };
}
